<template>
  <ClientsTable :noClientType="noClientType" :layout="layout !== 'add' ? 'projectStep' : layout" :clients="clients" :clientsTypes="clientsTypes"></ClientsTable>
</template>

<script type="text/javascript">
  import ClientsTable from "../../../Clients/components/ClientsTable/ClientsTable";
  import eventBus from "../../../../event-bus/eventBus";
  import {mapActions, mapState} from "vuex";

  export default {
    name: "ClientsTableForm",
    components: {ClientsTable},
    props: {
      layout: String,
      clients: Array,
      clientsTypes: Array,
      noClientType: Boolean
    },
    computed: {
      ...mapState("preventDataLost", {
        isDataChanged: state => state.isDataChanged,
      })
    },
    methods: {
      ...mapActions("getClient", ["getClient"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
    },
    mounted() {
      eventBus.$on("deleteClientStep", (item) => {
        this.clients.splice(item, 1);
      });
      eventBus.$on("addClientStep", (item) => {
        if (!this.isDataChanged) {
          this.updateDataInFormIsChanged(true);
        }
        this.clients.push(item);
      });
      eventBus.$on("setClientsForm", (item) => {
        this.clients = item;
      });
      eventBus.$on("saveClientSuccessProject", (id) => {
        this.getClient({creds: {id}});
      });
    },
    beforeDestroy() {
      eventBus.$off('addClientStep')
      eventBus.$off('saveClientSuccessProject')
    }
  }
</script>